import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoiceEditorContentWrapper = styled.div`
  margin-bottom: ${Spacing.S32};
  position: relative;
`
